<div role="presentation" class="ag-cell-editor ag-labeled ag-label-align-left ag-date-field ag-input-field" ref="eInput">
    <div ref="eLabel" class="ag-input-field-label ag-label ag-hidden ag-number-field-label" aria-hidden="true" role="presentation" id="ag-526-label"></div>
    <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-number-field-input-wrapper" role="presentation">
        <input
            #inputRef
            class="ag-input-field-input ag-number-field-input tt-grid__input--number"
            type="text"
            inputmode="decimal"
            tabindex="0"
            [(ngModel)]="_viewValue"
            (ngModelChange)="onModelChanged($event)"
            (focus)="inputRef.select()"
        />
    </div>
</div>
